import {
  Dialog,
  DialogContent,
} from "@/modern/components/ui/dialog-shadcn";
import { ConfiguratorGrid } from "./ConfiguratorGrid";
import { useConfiguratorContext } from "../context/DashboardConfiguratorContext";

interface DashboardConfiguratorModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DashboardConfiguratorModal({
  open,
  onOpenChange,
}: DashboardConfiguratorModalProps) {
  const { handleCloseConfigurator } = useConfiguratorContext();

  const handleClose = () => onOpenChange(false);

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      handleCloseConfigurator(() => onOpenChange(false));
      return;
    }
    onOpenChange(nextOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        showCloseButton={false}
        className="sm:max-w-[1200px] h-[85vh] p-0 gap-0 flex flex-col overflow-hidden"
      >
        <ConfiguratorGrid onClose={handleClose} />
      </DialogContent>
    </Dialog>
  );
}
